import { ImageIcon } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Card, Image } from 'src/shared/components/ui'
import { cn } from 'src/shared/components/ui/utils'

export const IllustrationPicker = ({
  productImages,
  selectedProductImage,
  onSelectProductImage,
  withTitle = true,
  withCard = true,
  large = false,
}) => {
  const content = (
    <Column className="gap-2">
      {withTitle && (
        <Row className="items-center gap-2">
          <ImageIcon className="w-4 h-4" />
          <p className="text-sm">Illustration</p>
        </Row>
      )}

      <div
        className={cn(
          'grid grid-cols-2 gap-2 overflow-y-auto border border-gray-200 rounded-lg p-2 bg-white',
          large ? 'h-[350px]' : 'h-[222px]'
        )}
      >
        {productImages?.product_image?.map((illustration_, idx) => {
          const { image_url } = illustration_
          const isSelected = image_url === selectedProductImage

          return (
            <Image
              key={image_url || idx}
              src={image_url || ''}
              className={cn(
                'rounded-md object-cover border-2 border-white w-full',
                'cursor-pointer border-gray-200',
                isSelected && 'border-blue-500'
              )}
              onClick={() => {
                onSelectProductImage(image_url)
              }}
            />
          )
        })}
      </div>
    </Column>
  )

  if (withCard) {
    return <Card>{content}</Card>
  }

  return content
}
